import { useState as f, useEffect as y } from "react";
import { PaymentUtils as o } from "../../../../js/payments/paymentUtils.js";
import { PaymentAPI as p } from "../../../../js/payments/paymentApi.js";
import { useEnvironment as R } from "../../common/hooks/environment/useEnvironment.js";
const w = {
  status: "idle",
  orderId: null,
  payment: null,
  error: null
};
function v(i = {}) {
  const { gatewayToken: u } = i, { paymentGatewayBaseUrl: c } = R(), [l, t] = f(w);
  return y(() => {
    const a = new URLSearchParams(window.location.search), s = o.getRedirectReturn(a);
    if (s === null)
      return;
    const { orderId: e, engineType: m } = s, d = a.get(p.REDIRECT_ENGINE_PARAM_WS_ID);
    let r = !0;
    return t({
      status: "verifying",
      orderId: e,
      payment: null,
      error: null
    }), o.verifyRedirectPaymentReturn({
      gatewayUrl: c,
      gatewayToken: u,
      orderId: e,
      wssUuid: d ?? void 0,
      engineType: m
    }).then((n) => {
      r && t({
        status: "accepted",
        orderId: e,
        payment: n,
        error: null
      });
    }).catch((n) => {
      r && t({
        status: "failed",
        orderId: e,
        payment: null,
        error: n
      });
    }), () => {
      r = !1;
    };
  }, []), l;
}
export {
  v as usePaymentRedirectVerification
};
//# sourceMappingURL=usePaymentRedirectVerification.js.map
